import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import LogOutIconfrom from '../../assets/LogOut.svg';
import './Auth.css'

/**
 * Renders a sign out button 
 */
export const SignOutButton = () => {
  const { instance } = useMsal();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async (logoutType) => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);
    if (logoutType === "popup") {
      try {
        await instance.logoutPopup({
          postLogoutRedirectUri: "/",
          mainWindowRedirectUri: "/",
        });
      } catch (e) {
        console.error('logoutPopup failed', e);
        setIsLoggingOut(false);
      }
    } else if (logoutType === "redirect") {
      try {
        // Typically redirects away, so state reset isn't necessary.
        await instance.logoutRedirect({
          postLogoutRedirectUri: "/",
        });
      } catch (e) {
        console.error('logoutRedirect failed', e);
        setIsLoggingOut(false);
      }
    }
  };

  return (
      <div onClick={() => handleLogout("redirect")} className='LogOut'>
        <img src={LogOutIconfrom} className='LogOutIcon'/>
        <div className='logoutText'>Log Out</div>
      </div>
  );
};

